import { datadogRum } from '@datadog/browser-rum';
import * as Sentry from '@sentry/react';

export const clearUser = (): void => {
  // Call DD first because setUser is Async
  datadogRum.setUser({});
  Sentry.setUser({});
  return;
};
